import { render, staticRenderFns } from "./StatFilter.vue?vue&type=template&id=42e5a064&scoped=true"
import script from "./StatFilter.vue?vue&type=script&lang=js"
export * from "./StatFilter.vue?vue&type=script&lang=js"
import style0 from "./StatFilter.vue?vue&type=style&index=0&id=42e5a064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e5a064",
  null
  
)

export default component.exports